import { useEffect } from "react";

interface PageMeta {
  title: string;
  description?: string;
  keywords?: string;
}

const setMeta = (attr: "name" | "property", key: string, value: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export function usePageMeta({ title, description, keywords }: PageMeta): void {
  useEffect(() => {
    document.title = title;
    setMeta("property", "og:title", title);
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    if (keywords) {
      setMeta("name", "keywords", keywords);
    }
  }, [title, description, keywords]);
}